var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline" },
    [_c("task-comment-tree-view", { attrs: { data: _vm.data } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }